/* Builds the exact markup shape website_hq/web_template/item_carousel/item_carousel.html
 * renders server-side for a Web Page Block, so window.rfhqProductCard.mountCarousel
 * (rfhq_templates.js's mountProductCarousel, exposed for this purpose) can mount
 * it identically regardless of whether the element came from Jinja or JS.
 *
 * PDP and checkout use this instead of a Web Page Block because neither page is
 * a Web Page document (PDP is a Generator template, checkout is a fixed Jinja
 * page under templates/pages/) - Frappe's Page Builder only attaches to
 * Web Page.page_blocks, so there's no way to give either page a real block.
 * This is the JS-side equivalent: same data-* attribute contract, same inner
 * markup, same mount function - only *how the element reaches the DOM* differs.
 *
 * Attribute values mirror the home page's "Recommended for you" Item Carousel
 * block exactly (card_layout=Featured, slides 1/2/4, nav on, pagination off,
 * autoplay/loop off) so all three surfaces render identically - see
 * mountProductCarousel's onEmpty for what happens when a surface's placement
 * setting is off or a fetch legitimately returns nothing.
 *
 * data-limit is deliberately omitted: mountProductCarousel falls back to a
 * generous ceiling (16) when unset, so the actual count is whatever
 * Raftor Storefront Feature Settings > Recommendation Fallback Count resolves
 * server-side - one place to configure "how many", not a number duplicated
 * into this file too.
 */

export function buildRecommendationCarouselEl(opts) {
	var el = document.createElement('div');
	el.className = 'rfhq-item-carousel ' + (opts.extraClass || '');
	el.dataset.source = 'Recommendation';
	el.dataset.recommendationMode = opts.mode;
	if (opts.itemCode) el.dataset.itemCode = opts.itemCode;
	el.dataset.filter = '';
	el.dataset.cardLayout = 'featured';
	el.dataset.showPrice = 'true';
	el.dataset.actionKind = 'automatic';
	el.dataset.slidesMobile = '1';
	el.dataset.slidesTablet = '2';
	el.dataset.slidesDesktop = '4';
	el.dataset.autoplay = 'false';
	el.dataset.loop = 'false';
	el.dataset.nav = 'true';
	el.dataset.pagination = 'false';

	el.innerHTML =
		'<div class="rfhq-section-header mb-4"><h2 class="section-title">' + opts.title + '</h2></div>' +
		'<div class="swiper rfhq-swiper">' +
		'<div class="swiper-wrapper rfhq-carousel-wrapper"></div>' +
		'<button class="swiper-button-next rfhq-swiper-next" type="button" aria-label="' + __('Next slide') + '"></button>' +
		'<button class="swiper-button-prev rfhq-swiper-prev" type="button" aria-label="' + __('Previous slide') + '"></button>' +
		'<div class="swiper-pagination rfhq-swiper-pagination"></div>' +
		'</div>';

	return el;
}
